<ng-container *ngIf="appName === 'pw'">
  <div class="mat-dialog-title upgrade-title">
    <div class="pw-dialog-header">
      <div class="pw-dialog-title">Upgrade to {{plan.plan}} Plus Plan?</div>
      <button mat-icon-button class="pw-dialog-close" aria-label="close bottom button [upgrade]" (click)="close()">
        <svg class="nr-icon-24">
          <use xlink:href="#pw_close"></use>
        </svg>
      </button>
    </div>
    <mat-divider></mat-divider>
  </div>
  <div mat-dialog-content class="dialog-pw-content">
    <div class="pw-upgrade-plus">
      <b>It only costs the difference in price</b> <br>
      <b>${{prorate}} / first payment</b> <br>
      or {{plan.price}} for renewal
    </div>
  </div>
  <mat-dialog-actions>
    <button mat-flat-button color="primary" class="btn-full" aria-label="upgrade now button"
      [disabled]="isUpgradingOnStripe" (click)="upgrade()">upgrade
      now</button>
    <button mat-button color="primary" class="btn-full" aria-label="go to demo page button"
      (click)="goToDemoPage()">Listen to demo</button>
    <button mat-button color="primary" class="btn-full" (click)="restoreLicenseClick()">RESTORE LICENSE</button>
  </mat-dialog-actions>
  <div class="upgrade-loading" *ngIf="showLoad">
    <div class="mat-title pw-text-indigo">Processing. . .</div>
    <p *ngIf="finishPurchases">The license will refresh in a few minutes. Thanks for your patience. </p>
    <button class="loading-close" mat-icon-button (click)="cancelLoading()">
      <svg class="nr-icon-24">
        <use xlink:href="#pw_close"></use>
      </svg>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="appName === 'ios' || appName === 'android'">

  <div class="pw-payment-old mobile"  *ngIf="false">
    <div class="pw-payment-header">
      <div class="pw-payment-logo">
        <svg class="nr-icon-30 icon-primary">
          <use xlink:href="#nr_logo"></use>
        </svg>
        <span class="nr-main-logo pw-text-primary">aturalReader</span>
      </div>
      <button mat-icon-button class="pw-payment-close" (click)="closePayment()" aria-label="close payment [payment]">
        <svg class="nr-icon-24">
          <use xlink:href="#pw_close"></use>
        </svg>
      </button>
    </div>

    <div class="pw-payment-row">
      <div class="pw-payment-choose">
        <div class="choose-body">
          <!-- <div class="choose-feature" *ngIf="isBestPlan">
            <div class="pw-payment-type pw-text-indigo">Plus Plan (with AI voices)</div>
            <ul class="choose-feature-list">
              <li>
                100+ Human-Like AI Plus Voices (500K characters per day)
              </li>
              <li>
                40+ Non-AI Premium Voices
              </li>
              <li>
                20+ languages
              </li>
              <li>
                Cross-platform access to web app and Chrome extension
              </li>
            </ul>
            <div class="row">
              <button mat-button color="primary" (click)="openCompare()">
                Show all features
                <svg class="nr-icon-24 icon-primary">
                  <use xlink:href="#nr_chevron_right"></use>
                </svg>
              </button>
            </div>
          </div>
          <div class="choose-feature" *ngIf="!isBestPlan">
            <div class="pw-payment-type pw-text-indigo">Premium Plan (Non-AI Voices)</div>
            <ul class="choose-feature-list">
              <li>
                40+ Non-AI Premium Voices
              </li>
              <li>
                8 languages
              </li>
              <li>
                Cross-platform access to web app and Chrome extension
              </li>
            </ul>
            <div class="row">
              <button mat-button color="primary" (click)="openCompare()">
                Show all features
                <svg class="nr-icon-24 icon-primary">
                  <use xlink:href="#nr_chevron_right"></use>
                </svg>
              </button>
            </div>
          </div> -->

          <div class="pw-payment-card-price" *ngIf="isBestPlan">
            <mat-radio-group class="pw-payment-price-group best-group" color="primary" [labelPosition]="'before'"
              name="bestPlans" [(ngModel)]="choosePlan" required>
              <mat-radio-button class="pw-payment-price-radio" checked [value]="bestPlus">
                <div class="choose-card">
                  <!-- <div class="choose-card-content">
                                    <div class="choose-card-header">
                                      <div>Plus Yearly</div>
                                      <div class="price-num">9.17 USD / month</div>
                                    </div>
                                    <button mat-flat-button color="primary" class="btn-full btn-pay" [disabled]="email == ''"
                                      aria-label="iap plus yearly button" (click)="buy('plus_yearly')">
                                      Pay $109.99 <span class="pw-payment-price-usd">USD</span>
                                    </button>
                                    <div class="choose-note">
                                      <div class="price-hint ">
                                        Billed yearly as a single payment of $109.99/year
                                      </div>
                                      <div class="price-discount ">(57% Discount)</div>
                                    </div>
                                    <div class="mat-caption pw-payment-notes">
                                      **All subscription services auto-renew at the end of the billing term unless explicitly cancelled by the user.
                                    </div>
                                  </div> -->
                  <div class="choose-card-header">
                    <div>Plus Yearly (With AI Voices)</div>
                  </div>
                  <div class="choose-card-content">
                    <div class="choose-feature">
                      <ul class="choose-feature-list">
                        <li>
                          100+ Human-Like AI Plus Voices<br>(500K characters per day)
                        </li>
                        <li>
                          40+ Non-AI Premium Voices
                        </li>
                        <li>
                          20+ languages
                        </li>
                      </ul>
                    </div>
                    <div class="choose-note">
                      <div class="price-num">9.17 USD / month</div>
                      <div class="price-discount ">(57% Discount)</div>
                    </div>
                  </div>
                  <div class="choose-hide">
                    <button mat-button class="btn-features" (click)="openCompare()">
                      Show all features
                      <svg class="nr-icon-24 ">
                        <use xlink:href="#nr_chevron_right"></use>
                      </svg>
                    </button>
                    <button mat-flat-button color="primary" class="btn-full btn-pay" [disabled]="email == ''"
                      aria-label="iap plus yearly button" (click)="buy('plus_yearly')">
                      Pay $109.99 <span class="pw-payment-price-usd">USD</span>
                    </button>
                  </div>
                  <div class="price-hint">
                    Billed yearly as a single payment of $109.99/year
                  </div>
                  <div class="mat-caption pw-payment-notes">
                    **All subscription services auto-renew at the end of the billing term unless explicitly cancelled by
                    the user.
                  </div>
                </div>
              </mat-radio-button>

              <mat-radio-button class="pw-payment-price-radio" *ngIf="userPlan === freePlan" [value]="bestPremium">
                <!-- <div class="choose-card">
                  <div class="choose-card-content">
                    <div class="choose-card-header">
                      <div>Premium Yearly</div>
                      <div class="price-num">4.99 USD / month</div>
                    </div>
                    <button mat-flat-button color="primary" class="btn-full btn-pay" [disabled]="email == ''"
                      aria-label="iap premium yearly button" (click)="buy('prem_yearly')">
                      Pay $59.99 <span class="pw-payment-price-usd">USD</span>
                    </button>
          
                    <div class="choose-note">
                      <div class="price-hint ">
                        Billed yearly as a single payment of $59.99/year
                      </div>
                      <div class="price-discount ">(50% Discount)</div>
                    </div>
                    <div class="mat-caption pw-payment-notes">
                      **All subscription services auto-renew at the end of the billing term unless explicitly cancelled by
                      the user.
                    </div>
                  </div>
                </div> -->
                <div class="choose-card">
                  <div class="choose-card-header">
                    <div>Premium Yearly (With Non-AI Voices)</div>
                  </div>
                  <div class="choose-card-content">
                    <div class="choose-feature">
                      <ul class="choose-feature-list">
                        <li>
                          40+ Non-AI Premium Voices
                        </li>
                        <li>
                          8 languages
                        </li>
                      </ul>
                    </div>
                    <div class="choose-note">
                      <div class="price-num">4.99 USD / month</div>
                      <div class="price-discount ">(50% Discount)</div>
                    </div>
                  </div>
                  <div class="choose-hide">
                    <button mat-button class="btn-features" (click)="openCompare()">
                      Show all features
                      <svg class="nr-icon-24 ">
                        <use xlink:href="#nr_chevron_right"></use>
                      </svg>
                    </button>
                    <button mat-flat-button color="primary" class="btn-full btn-pay" [disabled]="email == ''"
                      aria-label="iap premium yearly button" (click)="buy('prem_yearly')">
                      Pay $59.99 <span class="pw-payment-price-usd">USD</span>
                    </button>
                  </div>
                  <div class="price-hint">
                    Billed yearly as a single payment of $59.99/year
                  </div>
                  <div class="mat-caption pw-payment-notes">
                    **All subscription services auto-renew at the end of the billing term unless explicitly cancelled by
                    the user.
                  </div>
                </div>
              </mat-radio-button>
            </mat-radio-group>
            <button mat-button color="primary" class="btn-full" *ngIf="email != 'user@naturalreaders.com'"
              (click)="clickRestore()">
              Restore Purchases
            </button>

          </div>

          <div class="pw-payment-card-price" *ngIf="!isBestPlan">
            <mat-radio-group class="pw-payment-price-group flex-group" color="primary" [labelPosition]="'before'"
              name="flexiblePlans" [(ngModel)]="choosePlan" required>


              <mat-radio-button class="pw-payment-price-radio" checked [value]="flexPlus">
                <!-- <div class="choose-card">
                  <div class="choose-card-content">
                    <div class="choose-card-header">
                      <div>Plus Monthly</div>
                      <div class="price-num">18.99 USD / month</div>
                    </div>
                    <button mat-flat-button color="primary" class="btn-full btn-pay" [disabled]="email == ''"
                      aria-label="iap plus monthly button" (click)="buy('plus_monthly')">
                      Pay $18.99 <span class="pw-payment-price-usd">USD</span>
                    </button>
                    <div class="mat-caption pw-payment-notes">
                      **All subscription services auto-renew at the end of the billing term
                      unless explicitly cancelled by the user.
                    </div>
                  </div>
                </div> -->
                <div class="choose-card">
                  <div class="choose-card-header">
                    <div>Plus Monthly (With AI Voices)</div>
                  </div>
                  <div class="choose-card-content">
                    <div class="choose-feature">
                      <ul class="choose-feature-list">
                        <li>
                          100+ Human-Like AI Plus Voices<br>(500K characters per day)
                        </li>
                        <li>
                          40+ Non-AI Premium Voices
                        </li>
                        <li>
                          20+ languages
                        </li>
                      </ul>
                      <div class="choose-hide">
                        <button mat-button class="btn-features" (click)="openCompare()">
                          Show all features
                          <svg class="nr-icon-24 ">
                            <use xlink:href="#nr_chevron_right"></use>
                          </svg>
                        </button>
                        <button mat-flat-button color="primary" class="btn-full btn-pay" [disabled]="email == ''"
                          aria-label="iap plus monthly button" (click)="buy('plus_monthly')">
                          Pay $18.99 <span class="pw-payment-price-usd">USD</span>
                        </button>
                      </div>
                    </div>
                    <div class="choose-note">
                      <div class="price-num">18.99 USD / month</div>
                    </div>
                  </div>
                  <div class="mat-caption pw-payment-notes">
                    **All subscription services auto-renew at the end of the billing term
                    unless explicitly cancelled by the user.
                  </div>
                </div>
              </mat-radio-button>

              <mat-radio-button class="pw-payment-price-radio" *ngIf="userPlan === freePlan" [value]="flexPremium">
                <!-- <div class="choose-card">
                  <div class="choose-card-content">
                    <div class="choose-card-header">
                      <div>Premium Monthly</div>
                      <div class="price-num">9.99 USD / month</div>
                    </div>
                    <button mat-flat-button color="primary" class="btn-full btn-pay" [disabled]="email == ''"
                      aria-label="iap premium monthly button" (click)="buy('prem_monthly')">
                      Pay $9.99 <span class="pw-payment-price-usd">USD</span>
                    </button>
                    <div class="mat-caption pw-payment-notes">
                      **All subscription services auto-renew at the end of the billing term
                      unless explicitly cancelled by the user. </div>
                  </div>
                </div> -->
                <div class="choose-card">
                  <div class="choose-card-header">
                    <div>Premium Monthly (With Non-AI Voices)</div>
                  </div>
                  <div class="choose-card-content">
                    <div class="choose-feature">
                      <ul class="choose-feature-list">
                        <li>
                          40+ Non-AI Premium Voices
                        </li>
                        <li>
                          8 languages
                        </li>
                      </ul>
                      <div class="choose-hide">
                        <button mat-button class="btn-features" (click)="openCompare()">
                          Show all features
                          <svg class="nr-icon-24 ">
                            <use xlink:href="#nr_chevron_right"></use>
                          </svg>
                        </button>
                        <button mat-flat-button color="primary" class="btn-full btn-pay" [disabled]="email == ''"
                          aria-label="iap premium monthly button" (click)="buy('prem_monthly')">
                          Pay $9.99 <span class="pw-payment-price-usd">USD</span>
                        </button>
                      </div>
                    </div>
                    <div class="choose-note">
                      <div class="price-num">9.99 USD / month</div>
                    </div>
                  </div>
                  <div class="mat-caption pw-payment-notes">
                    **All subscription services auto-renew at the end of the billing term
                    unless explicitly cancelled by the user.
                  </div>
                </div>
              </mat-radio-button>
            </mat-radio-group>
            <button mat-button color="primary" class="btn-full" *ngIf="email != 'user@naturalreaders.com'"
              (click)="clickRestore()">
              Restore Purchases
            </button>
          </div>

          <div class="choose-header mobile">
            <button mat-button (click)="changePlan()" *ngIf="isBestPlan">
              <span>Monthly Payment Options (no discount)</span>
              <svg class="nr-icon-24">
                <use xlink:href="#nr_chevron_right"></use>
              </svg>
            </button>
            <button mat-button color="primary" (click)="changePlan()" *ngIf="!isBestPlan">
              <svg class="nr-icon-24 icon-primary">
                <use xlink:href="#nr_chevron_left"></use>
              </svg>
              <span>Back to Yearly Plans (50% discount)</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="pw-payment-row" *ngIf="!isUpgrade">
      <div class="pw-payment-choose">
        <div class="choose-body">

          <!-- <div class="choose-feature" >
            <div class="pw-payment-type pw-text-indigo">Premium Plan (Non-AI Voices)</div>
            <ul class="choose-feature-list">
              <li>
                40+ Non-AI Premium Voices
              </li>
              <li>
                8 languages
              </li>
              <li>
                Cross-platform access to web app and Chrome extension
              </li>
            </ul>
            <div class="row">
              <button mat-button class="pw-text-primary" (click)="openCompare()">
                Show all features
                <svg class="nr-icon-24 icon-primary">
                  <use xlink:href="#nr_chevron_right"></use>
                </svg>
              </button>
            </div>
          </div> -->

          <div class="pw-payment-card-price">
            <mat-radio-group class="pw-payment-price-group flex-group" color="primary" [labelPosition]="'before'"
              name="flexiblePlans">
              <mat-radio-button class="pw-payment-price-radio" selected *ngIf="!isMonthly">
                <!-- <div class="choose-card">
                  <div class="choose-card-content">
                    <div class="choose-card-header">
                      <div>Premium Yearly</div>
                      <div class="price-num">4.99 USD / month</div>
                    </div>

                    <button mat-flat-button color="primary" class="btn-full btn-pay" [disabled]="email == ''"
                      aria-label="iap premium yearly button" (click)="buy('prem_yearly')">
                      Pay $59.99 <span class="pw-payment-price-usd">USD</span>
                    </button>

                    <div class="choose-note">
                      <div class="price-hint ">
                        Billed yearly as a single payment of $59.99/year
                      </div>
                      <div class="price-discount ">(50% Discount)</div>
                    </div>

                    <div class="mat-caption pw-payment-notes">
                      **All subscription services auto-renew at the end of the billing term unless explicitly cancelled
                      by
                      the user.
                    </div>
                  </div>
                </div> -->
                <div class="choose-card">
                  <div class="choose-card-header">
                    <div>Premium Yearly (With Non-AI Voices)</div>
                  </div>
                  <div class="choose-card-content">
                    <div class="choose-feature">
                      <ul class="choose-feature-list">
                        <li>
                          40+ Non-AI Premium Voices
                        </li>
                        <li>
                          8 languages
                        </li>
                      </ul>
                    </div>
                    <div class="choose-note">
                      <div class="price-num">4.99 USD / month</div>
                      <div class="price-discount ">(50% Discount)</div>
                    </div>
                  </div>
                  <div class="choose-hide">
                    <button mat-button class="btn-features" (click)="openCompare()">
                      Show all features
                      <svg class="nr-icon-24 ">
                        <use xlink:href="#nr_chevron_right"></use>
                      </svg>
                    </button>
                    <button mat-flat-button color="primary" class="btn-full btn-pay" [disabled]="email == ''"
                      aria-label="iap premium yearly button" (click)="buy('prem_yearly')">
                      Pay $59.99 <span class="pw-payment-price-usd">USD</span>
                    </button>
                  </div>
                  <div class="price-hint">
                    Billed yearly as a single payment of $59.99/year
                  </div>
                  <div class="mat-caption pw-payment-notes">
                    **All subscription services auto-renew at the end of the billing term unless explicitly cancelled by
                    the user.
                  </div>
                </div>
              </mat-radio-button>

              <mat-radio-button class="pw-payment-price-radio" selected *ngIf="isMonthly">
                <!-- <div class="choose-card">
                  <div class="choose-card-content">
                    <div class="choose-card-header">
                      <div>Premium Monthly</div>
                      <div class="price-num">9.99 USD / month</div>
                    </div>
                    <button mat-flat-button color="primary" class="btn-full btn-pay" [disabled]="email == ''"
                      aria-label="iap premium monthly button" (click)="buy('prem_monthly')">
                      Pay $9.99 <span class="pw-payment-price-usd">USD</span>
                    </button>
                    <div class="mat-caption pw-payment-notes">
                      **All subscription services auto-renew at the end of the billing term
                      unless explicitly cancelled by the user.
                    </div>
                  </div>
                </div> -->
                <div class="choose-card">
                  <div class="choose-card-header">
                    <div>Premium Monthly (With Non-AI Voices)</div>
                  </div>
                  <div class="choose-card-content">
                    <div class="choose-feature">
                      <ul class="choose-feature-list">
                        <li>
                          40+ Non-AI Premium Voices
                        </li>
                        <li>
                          8 languages
                        </li>
                      </ul>
                      <div class="choose-hide">
                        <button mat-button class="btn-features" (click)="openCompare()">
                          Show all features
                          <svg class="nr-icon-24 ">
                            <use xlink:href="#nr_chevron_right"></use>
                          </svg>
                        </button>
                        <button mat-flat-button color="primary" class="btn-full btn-pay" [disabled]="email == ''"
                          aria-label="iap premium monthly button" (click)="buy('prem_monthly')">
                          Pay $9.99 <span class="pw-payment-price-usd">USD</span>
                        </button>
                      </div>
                    </div>
                    <div class="choose-note">
                      <div class="price-num">9.99 USD / month</div>
                    </div>
                  </div>
                  <div class="mat-caption pw-payment-notes">
                    **All subscription services auto-renew at the end of the billing term
                    unless explicitly cancelled by the user.
                  </div>
                </div>
              </mat-radio-button>
            </mat-radio-group>
            <button mat-button color="primary" class="btn-full" *ngIf="email != 'user@naturalreaders.com'"
              (click)="clickRestore()">
              Restore Purchases
            </button>
          </div>

        </div>
      </div>
    </div>

    <div class="pw-loading upgrade-loading" *ngIf="showLoad">
      <div class="pw-loading-logo">
        <svg class="nr-icon-80" viewBox="0 0 192 192" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect id="pw-loader-1" width="14" height="192" rx="7" fill="#0078d4" />
          <rect id="pw-loader-2" x="22.2617" width="14" height="192" rx="7" fill="#0078d4" />
          <rect id="pw-loader-3" x="44.5215" width="14" height="192" rx="7" fill="#0078d4" />
          <rect id="pw-loader-4" x="66.7832" y="29.1182" width="13.9131" height="90.0853" rx="6.95653" fill="#0078d4" />
          <path id="pw-loader-5"
            d="M89.043 63.2416C89.043 59.4725 92.1575 56.417 95.9995 56.417C99.8415 56.417 102.956 59.4725 102.956 63.2416V137.858C102.956 141.627 99.8415 144.682 95.9995 144.682C92.1575 144.682 89.043 141.627 89.043 137.858V63.2416Z"
            fill="#0078d4" />
          <rect id="pw-loader-6" x="111.305" y="80.0762" width="13.9131" height="90.9953" rx="6.95653" fill="#0078d4" />
          <rect id="pw-loader-7" x="133.564" width="13.9131" height="192" rx="6.95653" fill="#0078d4" />
          <rect id="pw-loader-8" x="155.826" width="13.9131" height="192" rx="6.95653" fill="#0078d4" />
          <rect id="pw-loader-9" x="178.088" width="13.9131" height="192" rx="6.95653" fill="#0078d4" />
        </svg>

      </div>
      <h4>Processing. . .</h4>
      <p *ngIf="finishPurchases">The license will refresh in a few minutes. Thanks for your patience. </p>
      <button class="loading-close" mat-icon-button (click)="cancelLoading()">
        <svg class="nr-icon-24">
          <use xlink:href="#pw_close"></use>
        </svg>
      </button>
    </div>
  </div>

  <div class="pw-payment-new" *ngIf="!isAppPaid">
    <div class="pw-payment-header">
        <div class="pw-payment-logo">
            <svg class="nr-icon-36">
                <use xlink:href="#nr_logo"></use>
            </svg>
            <span class="nr-main-logo">aturalReader</span>
        </div>
        <button mat-icon-button class="pw-payment-close" (click)="closePayment()" aria-label="close payment [payment]">
            <svg class="nr-icon-24">
                <use xlink:href="#pw_close"></use>
            </svg>
        </button>
    </div>

    <div class="pw-payment-row">
        <div class="pw-payment-choose">
            <div class="pw-text-indigo pw-choose-title">
                Plus Plan (with AI voices)
            </div>

            <div class="pw-payment-features">
                <ul>
                    <li>
                        200+ AI Voices, 90+ Languages (500K Daily Characters)
                    </li>

                    <!-- <li>
                        Chrome Extension Included
                    </li>

                    <li>
                        Mobile App Included
                    </li> -->

                    <li>
                        MP3 Download (1 Million Monthly Characters)
                    </li>

                    <li>
                        Voice Cloning
                    </li>

                    <li>
                        2000+ Community Voices
                    </li>
                </ul>
            </div>

            <div class="pw-payment-footer">
                <div class="pw-payment-tips">
                    Mp3 files cannot be used for non-personal purposes 
                    <a href="https://www.naturalreaders.com/commercial.html" target="_blank" class="pw-text-primary">
                        (more info)
                    </a>
                </div>
                <div class="pw-payment-links">
                    <a mat-button class="pw-text-indigo text-uppercase" href="https://www.naturalreaders.com/policies.html#refund" target="_blank">
                        REFUND POLICIES
                    </a>
                    <a mat-button class="pw-text-indigo text-uppercase" href="https://www.naturalreaders.com/policies.html#privacy" target="_blank">
                        Privacy policy
                    </a>
                    <!-- <button mat-button class="pw-text-indigo text-uppercase" (click)="openCompare()">
                        COMPARE PLANS
                    </button> -->
                </div>
            </div>
        </div>

        <div class="pw-payment-info">
            <div class="info-card">
                <!-- <mat-radio-group class="pw-payment-plan-group" color="primary" [labelPosition]="'before'" name="Monthly"
                    [value]="selectedPlan" required>
                    <mat-radio-button class="pw-payment-plan-radio yearly" [value]="yearlyValue" (click)="changeChoosePlan(false)">Yearly</mat-radio-button>
                    <mat-radio-button class="pw-payment-plan-radio monthly" [value]="monthlyValue" (click)="changeChoosePlan(true)">Monthly</mat-radio-button>
                </mat-radio-group> -->

                <mat-radio-group class="pw-payment-price-group" color="primary" [labelPosition]="'before'" name="Yearly"
                    [value]="selectedPlan" required>
                    <mat-radio-button class="pw-payment-price-radio" [value]="yearlyValue">
                        <div class="choose-card">
                            <div class="choose-note">
                              <span>(57% Discount)</span>
                            </div> 

                            <div class="choose-card-header">
                                <div>Yearly</div>
                                <div>{{plusYearlyPrice.averagePrice}} {{plusYearlyPrice.currency}} / month</div>
                            </div>
                            
                            <div class="price-hint">
                                Billed yearly as a single payment of {{plusYearlyPrice.price}}/year
                            </div>
                        </div>
                    </mat-radio-button>
                
                    <mat-radio-button class="pw-payment-price-radio" [value]="monthlyValue">
                        <div class="choose-card">
                            <div class="choose-card-header">
                                <div>Monthly</div>
                                <div>{{plusMonthlyPrice.averagePrice}} {{plusMonthlyPrice.currency}} / month</div>
                            </div>
                        </div>
                    </mat-radio-button>
                </mat-radio-group>

                <div>
                  <button mat-button class="pw-payment-plan yearly" *ngIf="!isMonthly" (click)="changeChoosePlan(true)">
                      View Monthly <span>Payment</span> Options (No Discount)
                  </button>
                  <button mat-button class="pw-payment-plan monthly" *ngIf="isMonthly" (click)="changeChoosePlan(false)">
                      Back to yearly plan ({{plusYearlyPrice.averagePrice}} {{plusYearlyPrice.currency}}/month)
                  </button>
              </div>

                <!-- <div class='processing'>{{processing}}</div> -->
                <button (click)="buy('plus_yearly')" [disabled]="!checked || email == ''" mat-flat-button
                    color="primary" class="pw-payment-card-pay" aria-label="pay button [payment]" *ngIf="!isMonthly">
                    Pay {{plusYearlyPrice.price}} {{plusYearlyPrice.currency}}
                </button>
                <button (click)="buy('plus_monthly')" [disabled]="!checked || email == ''" mat-flat-button
                    color="primary" class="pw-payment-card-pay" aria-label="pay button [payment]" *ngIf="isMonthly">
                    Pay {{plusMonthlyPrice.price}} {{plusMonthlyPrice.currency}}
                </button>
                <button mat-button color="primary" class="btn-full" *ngIf="email != 'user@naturalreaders.com'"
                  (click)="clickRestore()">
                  Restore Purchases
                </button>
            </div>
        </div>
    </div>

    <div class="pw-loading upgrade-loading" *ngIf="showLoad">
      <div class="pw-loading-logo">
        <svg class="nr-icon-80" viewBox="0 0 192 192" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect id="pw-loader-1" width="14" height="192" rx="7" fill="#0078d4" />
          <rect id="pw-loader-2" x="22.2617" width="14" height="192" rx="7" fill="#0078d4" />
          <rect id="pw-loader-3" x="44.5215" width="14" height="192" rx="7" fill="#0078d4" />
          <rect id="pw-loader-4" x="66.7832" y="29.1182" width="13.9131" height="90.0853" rx="6.95653" fill="#0078d4" />
          <path id="pw-loader-5"
            d="M89.043 63.2416C89.043 59.4725 92.1575 56.417 95.9995 56.417C99.8415 56.417 102.956 59.4725 102.956 63.2416V137.858C102.956 141.627 99.8415 144.682 95.9995 144.682C92.1575 144.682 89.043 141.627 89.043 137.858V63.2416Z"
            fill="#0078d4" />
          <rect id="pw-loader-6" x="111.305" y="80.0762" width="13.9131" height="90.9953" rx="6.95653" fill="#0078d4" />
          <rect id="pw-loader-7" x="133.564" width="13.9131" height="192" rx="6.95653" fill="#0078d4" />
          <rect id="pw-loader-8" x="155.826" width="13.9131" height="192" rx="6.95653" fill="#0078d4" />
          <rect id="pw-loader-9" x="178.088" width="13.9131" height="192" rx="6.95653" fill="#0078d4" />
        </svg>

      </div>
      <h4>Processing. . .</h4>
      <p *ngIf="finishPurchases">The license will refresh in a few minutes. Thanks for your patience. </p>
      <button class="loading-close" mat-icon-button (click)="cancelLoading()">
        <svg class="nr-icon-24">
          <use xlink:href="#pw_close"></use>
        </svg>
      </button>
    </div>
  </div>

  <div class="pw-payment-thanks" *ngIf="isAppPaid">
    <!-- <div class="card-content" aria-label="iap success frame">
        <div class="d-flex justify-content-end">
          <button mat-icon-button class="pw-payment-close" (click)="closePayment()">
            <svg class="nr-icon-24">
              <use xlink:href="#pw_close"></use>
            </svg>
          </button>
        </div>
        <div class="mat-subheading-1">Success</div>
        <div class="paid-content">
          <p>Dear {{email}},</p>
          <p>Thank you for your purchase! Here are the details of your order.</p>
          <p>
            <b>Your plan:</b><br>
            {{planName}}
          </p>
          <p>
            <b>Desktop access:</b><br>
            Your subscription can also be accessed on desktop via our Chrome Extension and Web Application.<br>
            <a class="pw-text-primary"
              href="https://www.naturalreaders.com/online">https://www.naturalreaders.com/online</a>
          </p>
          <p>
            <b>Next payment date:</b><br>
            {{nextPaymentDate}}
          </p>
          <p>
            <b>Canceling subscription:</b>
          </p>
          <p *ngIf="appName === 'ios'">
            This subscription will automatically renew unless you cancel it. You can cancel the subscription at
            anytime by opening your Settings app > Your Name > Subscriptions > NaturalReader > Cancel
            Subscription. If you don't see Cancel Subscription, the subscription was already canceled and won't
            renew.
          </p>
          <p *ngIf="appName === 'android'">
            This subscription will automatically renew unless you cancel it. Uninstalling the app will not
            cancel your subscription. On your Android phone or tablet, open the Google Play Store, tap Menu
            Subscriptions, and select the subscription you want to cancel.
          </p>
        </div>
      </div> -->

    <div aria-label="iap success frame">
      <div class="mat-dialog-title">
        <div class="pw-dialog-header">
          <div class="pw-dialog-title">Success</div>
          <button mat-icon-button class="pw-dialog-close" (click)="closePayment()">
            <svg class="nr-icon-24">
              <use xlink:href="#pw_close"></use>
            </svg>
          </button>
        </div>
        <mat-divider></mat-divider>
      </div>
      <mat-dialog-content>
        <div class="paid-content">
          <p>Dear {{email}},</p>
          <p>Thank you for your purchase! Here are the details of your order.</p>
          <p>
            <b>Your plan:</b><br>
            {{planName}}
          </p>
          <p>
            <b>Desktop access:</b><br>
            Your subscription can also be accessed on desktop via our Chrome Extension and Web Application.<br>
            <a class="pw-text-primary"
              href="https://www.naturalreaders.com/online">https://www.naturalreaders.com/online</a>
          </p>
          <p>
            <b>Next payment date:</b><br>
            {{nextPaymentDate}}
          </p>
          <p>
            <b>Canceling subscription:</b>
          </p>
          <p *ngIf="appName === 'ios'">
            This subscription will automatically renew unless you cancel it. You can cancel the subscription at
            anytime by opening your Settings app > Your Name > Subscriptions > NaturalReader > Cancel
            Subscription. If you don't see Cancel Subscription, the subscription was already canceled and won't
            renew.
          </p>
          <p *ngIf="appName === 'android'">
            This subscription will automatically renew unless you cancel it. Uninstalling the app will not
            cancel your subscription. On your Android phone or tablet, open the Google Play Store, tap Menu
            Subscriptions, and select the subscription you want to cancel.
          </p>
        </div>
      </mat-dialog-content>
    </div>

  </div>


  <svg width="0" height="0" class="hidden">
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" id="payment_logo">
      <rect width="3.47826" height="48" rx="1.73913"></rect>
      <rect x="5.56519" width="3.47826" height="48" rx="1.73913"></rect>
      <rect x="11.1306" width="3.47826" height="48" rx="1.73913"></rect>
      <rect x="16.6958" y="7.27991" width="3.47826" height="22.5213" rx="1.73913"></rect>
      <path
        d="M22.2607 15.8108C22.2607 14.8685 23.0394 14.1046 23.9999 14.1046C24.9604 14.1046 25.739 14.8685 25.739 15.8108V34.4648C25.739 35.4071 24.9604 36.171 23.9999 36.171C23.0394 36.171 22.2607 35.4071 22.2607 34.4648V15.8108Z">
      </path>
      <rect x="27.8262" y="20.0189" width="3.47826" height="22.7488" rx="1.73913"></rect>
      <rect x="33.3914" width="3.47826" height="48" rx="1.73913"></rect>
      <rect x="38.9565" width="3.47826" height="48" rx="1.73913"></rect>
      <rect x="44.5217" width="3.47826" height="48" rx="1.73913"></rect>
    </symbol>
  </svg>
</ng-container>